<template>
    <div>
        <main id="content" role="main">
            <!-- Change Password Form -->
            <div class="container space-2">
                <form @submit="submit_form" class="js-validate w-md-75 w-lg-50 mx-md-auto">
                    <!-- Title -->
                    <div class="mb-7">
                        <h2 class="h3 text-primary font-weight-normal mb-0">
                            Bien<span class="font-weight-semi-bold">venue</span>
                        </h2>
                        <p>Changez votre mot de passe..</p>
                    </div>
                    <!-- End Title -->

                    <!-- Form Group -->
                    <div class="js-form-message form-group">
                        <label class="form-label" for="signinSrPassword">Mot de passe</label>
                        <input v-model="password" type="password" class="form-control" name="password"
                               id="signinSrPassword" placeholder="********" aria-label="********" required
                               data-msg="Votre mot de passe est invalide. Veuillez réessayer"
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>
                    <!-- End Form Group -->

                    <!-- Form Group -->
                    <div class="js-form-message form-group">
                        <label class="form-label" for="signinSrConfirmPassword">Mot de passe confirmation</label>
                        <input v-model="passwordConfirm" type="password" class="form-control" name="confirmPassword"
                               id="signinSrConfirmPassword" placeholder="********" aria-label="********" required
                               data-msg="Ce mot de passe ne correspond pas au mot de passe précédent."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>
                    <!-- End Form Group -->

                    <!-- Submit Errors -->
                    <div class="mb-7">
                        <p v-if="error" class="text-danger">{{ error }}</p>
                    </div>
                    <!-- End Submit Errors -->

                    <!-- Button -->
                    <div class="row align-items-center mb-5">
                        <div class="col-6">
                            <span class="small text-muted">Vous n'avez pas encore de compte?</span>
                            <router-link class="small" :to="{'name': 'signup'}">S'inscrire</router-link>
                        </div>

                        <div class="col-6 text-right">
                            <LoadingButton v-if="requestIsLoading"/>
                            <button v-else type="submit" class="btn btn-primary transition-3d-hover"
                                    v-bind:disabled="!isFormValid">Soumettre</button>
                        </div>
                    </div>
                    <!-- End Button -->

                </form>
            </div>
            <!-- Change Password Form -->
        </main>

        <a ref="openBasicModal" class="btn btn-sm btn-primary transition-3d-hover" href="#basicModal"
           data-modal-target="#basicModal" hidden>
            Open basic modal
        </a>
        <BasicModal :title="modal.title" :text="modal.text" :next="modal.next"/>

        <script type="application/javascript" v-bind:src="hsCoreSrc"></script>
        <script type="application/javascript" v-bind:src="hsModalWindowSrc"></script>
        <script type="application/javascript" v-bind:src="hsPluginsInitSrc"></script>
    </div>
</template>

<script>
    import LoadingButton from "../../components/LoadingButton";
    import {CHANGE_PASSWORD} from "../../settings/graphql";
    import {errorMessageDisplay} from "../../xlib/graphql";
    import {JS_FILES} from "../../settings/scripts";
    import BasicModal from "../../components/BasicModal";

    export default {
        name: "ChangePassword",
        components:{LoadingButton, BasicModal},
        data() {
            return {
                password: "",
                passwordConfirm: "",
                error: null,
                requestIsLoading: false,
                modal: {
                    text: "",
                    title: "",
                    next: ""
                },
                hsCoreSrc: JS_FILES.hs.core,
                hsModalWindowSrc: JS_FILES.hs.modalWindow,
                hsPluginsInitSrc: JS_FILES.hs.pluginsInit.modalWindow
            };
        },
        computed: {
            isFormValid: function () {
                return this.password === this.passwordConfirm;
            }
        },
        methods: {
            submit_form(event) {
                event.preventDefault();
                this.$data.requestIsLoading = true;

                const {uid, token} = this.$route.params;
                const newPassword = this.$data.password;

                this.$apollo.mutate({
                    mutation: CHANGE_PASSWORD,
                    variables: {uid, token, newPassword}
                }).then(() => {
                    // console.log(result.data);
                    this.$data.requestIsLoading = false;
                    this.$data.modal = {
                        title: "Mot de passe changé",
                        text: `Mot de passe changé`,
                        next: 'login'
                    };
                    this.$refs.openBasicModal.click();
                }).catch((error) => {
                    // console.error(`We encountered error ${error} on favorite tags updating...`);
                    this.$data.error = errorMessageDisplay(error);
                    this.$data.requestIsLoading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>